import React from 'react';
import PlantNav from './navs/PlantNav';
import ChangePassword from './updateProfileComponents/ChangePassword';

const UpdatePassword = () => {
    return (
        <div>
            <PlantNav />
            <ChangePassword />
        </div>
    )
}

export default UpdatePassword;
